export default {
  "content": "<title>Image</title><rect x=\"48\" y=\"80\" width=\"416\" height=\"352\" rx=\"48\" ry=\"48\" class=\"ionicon-fill-none ionicon-stroke-width\"/><circle cx=\"336\" cy=\"176\" r=\"32\" class=\"ionicon-fill-none ionicon-stroke-width\"/><path d=\"M304 335.79l-90.66-90.49a32 32 0 00-43.87-1.3L48 352m176 80l123.34-123.34a32 32 0 0143.11-2L464 368\" class=\"ionicon-fill-none ionicon-stroke-width\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "class": "ionicon",
    "viewBox": "0 0 512 512"
  }
};